import React, { FC, useEffect, useState } from "react";
import { Form, Modal, Button } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import {
  errorMessage,
  successMessage,
} from "../../../../utils/notificationUtils";
import dayjs from "dayjs";
import PreAuthStarHealth from "../../../../components/patient/PreAuth/StarHealth/PreAuthStarHealth";
import {
  deleteBillCategory,
  getBillCategories,
  getBillSubCategories,
  getDoctorQualification,
  getStarHealthChronicIllnessList,
  getStarHealthDiagnosisList,
  getStarHealthProcedureList,
  getStarHealthReasonHospitalizationList,
  getStarHealthSpecialityList,
  submitStarHealthPreAuth,
  saveDraftStarhealth,
  fetchPreAuthToPortalStarhealth,
  getStarHealthDocuments,
  updateDraftStarhealth,
} from "../../../../apis/SchemeService/STARHEALTH/starHealthService";
import {
  getBasicDetails,
  getDeficiencyQuestionData,
  getTimelineDetails,
} from "../../../../models/patientSlice";
import {
  fetchStepperData,
  getPortalDataStarhealth,
} from "../../../../models/preAuthSlice";
import { IUploadReferral } from "../../../../interfaces/IReferral";
import { IDocumentFields } from "../../../../interfaces/ICase";
import FilePreviewModal from "../../../../components/patient/PreAuth-query/FilePreviewModal";
import RightSidePreviewModal from "../../../../components/modals/RightSidePreviewModal";
import {
  deleteUploadedDocument,
  downloadDocument,
  getAllStarhealthDocumentsData,
  submitApprovalStarhealth,
  updateAllDocumentsData,
} from "../../../../apis/patientService";
import PatientDetailsStageDocument from "../../../../components/modals/PatientDetailsStageDocument";
import DocumentDeficiencyModal from "../../../../components/patient/DocumentDeficiencyModal";
import PortalSubmissionModal from "../../../../components/patient/PreAuth/PortalSubmissionModal";
import ManuallyIdModal from "../../../../components/patient/PreAuth/ManuallyIdModal";
import PortalSubmitModal from "../../../../components/patient/PreAuth/PortalSubmitModal";
import ConfirmSubmissionModalStage from "../../../../components/modals/ConfirmSubmissionModalStage";
import { UploadDocument } from "../../../../models/EnhancementSlice";
import { message } from "antd";
import { validationPreAuth } from "../../../../apis/PreAuthService";
import DocumentUploadModal from "../../../../components/patient/PreAuth/StarHealth/DocumentUploadModal";
import { UploadOutlined } from "@ant-design/icons";
import ManuallyClaimIdPortal from "../../../../components/patient/PreAuth/ManuallyClaimIdPortal";
import MultipleFilesPreviewModal from "../../../../components/patient/PreAuth-query/MultipleFilesPreviewModal";
import PortalClaimValidationModal from "../../../../components/patient/Portal Registration/PortalClaimValidationModal";
import {
  handlePortalClaimValidationFlow,
  updatePortalClaimValidation,
} from "../../../../utils/portalClaimValidation";

interface FormValues {
  starhealthHospitalizationReason: {
    id: number;
    name: string;
  };
  procedureCorporateMapping: {
    id: number;
    name: string;
  };
  treatmentType: number;
  starhealthProcedureDiagnosis: {
    id: number;
    name: string;
  };
  dateOfDiagnosis: dayjs.Dayjs;
  chronicIllness: {
    id: number;
    name: string;
  };
  chronicIllnessDate?: dayjs.Dayjs;
  noOfMonths?: number;
  doctorName: string;
  doctorQualification: string;
  department?: {
    id: number;
    name: string;
  };
  otherProcedureText?: string;
  otherProcedureDiagnosisText?: string;
  casePreAuthStarhealthBillDetailsRequestList: Array<{
    irdaiBillCategoryId: number;
    starHealthBillSubCategoryId: number;
    numberOfUnits: number;
    estimateAmount: number;
  }>;
}

interface PreAuthStarHealthContainerProps {
  activeKey: string | string[];
  sseData?: any;
  sseUpdateCount?: any;
}

interface Document {
  documentType: string;
  documentName?: string | null;
  documentUrl?: string | null;
  documentLabelType?: string | null;
  label: string;
  required?: boolean;
  requestDocument?: boolean;
  responseDocument?: boolean;
  id?: number;
  deficiencyCheckStatus?: string | null;
}

const PreAuthStarHealthContainer: FC<PreAuthStarHealthContainerProps> = ({
  activeKey,
  sseData,
  sseUpdateCount,
}): JSX.Element => {
  const dispatch = useDispatch<AppDispatch>();
  const { patients, preAuth, auth, enhancement } = useSelector(
    (state: RootState) => state
  );
  const [form] = Form.useForm();

  // State for dropdown options
  const [reasonList, setReasonList] = useState<any[]>([]);
  const [diagnosisList, setDiagnosisList] = useState<any[]>([]);
  const [chronicIllnessList, setChronicIllnessList] = useState<any[]>([]);
  const [procedureList, setProcedureList] = useState<any[]>([]);
  const [specialityList, setSpecialityList] = useState<any[]>([]);
  const [qualificationList, setQualificationList] = useState<any[]>([]);
  const [billCategories, setBillCategories] = useState<any[]>([]);
  const [billSubCategories, setBillSubCategories] = useState<any[]>([]);

  const [allBillSubCategories, setAllBillSubCategories] = useState<{
    [key: number]: any[];
  }>({});

  // Loading states
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isLoadingDropdowns, setIsLoadingDropdowns] = useState<boolean>(false);
  const [isSaving, setIsSaving] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isIntimating, setIsIntimating] = useState<boolean>(false);

  // Document states
  const [documentTypes, setDocumentTypes] = useState<Document[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [documentTags, setDocumentTags] = useState<any>([]);
  const [selectedQuestionTag, setSelectedQuestionTag] = useState<any>();
  const [documentUrls, setDocumentUrls] = useState<
    {
      documentType: string;
      documentName: string;
      documentUrl: string;
      id: number;
      referenceType: string | null;
      documentLabelType: any;
      deficiencyCheckStatus: any;
      remarks: string | null;
    }[]
  >([]);
  const [selectedFile, setSelectedFile] = useState<{
    file: File;
    documentType: string;
  } | null>(null);
  const [previewFile, setPreviewFile] = useState({
    url: "",
    name: "",
    showUpload: false,
    documentType: "",
  });
  const [previewModalVisible, setPreviewModalVisible] = useState(false);
  const [previewDocument, setPreviewDocument] = useState(false);
  const [documentName, setDocumentName] = useState("");
  const [clickedActiveTab, setClickedActiveTab] = useState<any>();
  const [clickedActiveDocumentUrl, setClickedActiveDocumentUrl] =
    useState<any>();
  const [deficiencyModal, setDeficiencyModal] = useState(false);
  const [selectedDocument, setSelectedDocument] =
    useState<IDocumentFields | null>(null);
  const [fetchingDeficiencyData, setFetchingDeficiencyData] =
    useState<boolean>(false);

  // Modal states
  const [showSaveModal, setShowSaveModal] = useState<boolean>(false);
  const [showIntimateModal, setShowIntimateModal] = useState<boolean>(false);
  const [showSubmitModal, setShowSubmitModal] = useState<boolean>(false);
  const [modalValues, setModalValues] = useState<FormValues | null>(null);
  const [manuallyClaimIdPortal, setManuallyClaimIdPortal] =
    useState<boolean>(false);
  const dateFormat = "DD-MM-YYYY HH:mm:ss";

  const [selectedFiles, setSelectedFiles] = useState<
    { file: File; documentType: string }[]
  >([]);
  const [previewFiles, setPreviewFiles] = useState<
    {
      url: string;
      name: string;
      showUpload: boolean;
      documentType: string;
      isMultiple: boolean;
    }[]
  >([]);

  const isPreAuthTabActive = () => {
    if (!activeKey || activeKey.length === 0) return false;

    const currentStageId =
      typeof activeKey === "string"
        ? parseInt(activeKey)
        : parseInt(activeKey?.[0]);

    const currentStage = preAuth?.stepperData?.visitStages?.find(
      (stage: any) => stage?.visitStageId === currentStageId
    );

    return currentStage?.visitStage?.toUpperCase() === "PREAUTH";
  };

  useEffect(() => {
    if (!previewModalVisible) {
      setSelectedFiles([]);
    }
  }, [previewModalVisible]);

  // Total amount state
  const [totalAmount, setTotalAmount] = useState<number>(0);

  // Watch form values for calculations
  const casePreAuthStarhealthBillDetailsRequestList = Form.useWatch(
    "casePreAuthStarhealthBillDetailsRequestList",
    form
  );
  const selectedProcedure = Form.useWatch("procedureCorporateMapping", form);

  // Submission states
  const [isSubmittedOnPortal, setIsSubmittedOnPortal] =
    useState<boolean>(false);
  const [isManuallyEnteredId, setIsManuallyEnteredId] = useState(false);
  const [submissionModal, setSubmissionModal] = useState<boolean>(false);
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [title, setTitle] = useState<string>("");
  const [confirmationState, setConfirmationState] = useState<string>("");
  const [showDocuments, setShowDocuments] = useState<boolean>(true); // to show only documents
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const [validationRes, setValidationRes] = useState<any>(null);
  const [isValidationLoading, setIsValidationLoading] = useState(false);
  const [registrationValidationStatus, setRegistrationValidationStatus] =
    useState<any>(null);

  // Document request/response documents state
  const [
    documentRequestResponseDocuments,
    setDocumentRequestResponseDocuments,
  ] = useState<any>();

  // Add isApproved state
  const [isApproved, setIsApproved] = useState<boolean>(false);
  const [isApprovedInitiated, setIsApprovedInitiated] =
    useState<boolean>(false);

  // Add new states for DocumentUploadModal
  const [uploadModalVisible, setUploadModalVisible] = useState<boolean>(false);
  const [selectedDocumentType, setSelectedDocumentType] = useState<any>({
    documentLabelType: null,
    documentType: null,
    isMultiple: true,
  });
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const [uploadFileList, setUploadFileList] = useState<any[]>([]);

  useEffect(() => {
    const fetchDiagnosisData = async () => {
      try {
        if (selectedProcedure?.id) {
          const portalMetaDataId =
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
          const hospitalId =
            patients?.fetchBasicDetails?.casesResponse?.healthCareId;
          const schemeId =
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

          if (portalMetaDataId && hospitalId && schemeId) {
            const diagnosisRequest = {
              procedureCooperateMappingId: selectedProcedure?.id,
            };

            const res = await getStarHealthDiagnosisList(
              portalMetaDataId,
              hospitalId,
              schemeId,
              diagnosisRequest
            );

            setDiagnosisList(
              res?.map((item: any) => ({
                id: item.id,
                starhealthProcedureDiagnosisId:
                  item.starhealthProcedureDiagnosisId,
                illnessName: item.illnessName,
                procedureCorporateMappingId: item.procedureCorporateMappingId,
                value: item.starhealthProcedureDiagnosisId,
                label: item.illnessName,
              })) || []
            );
          }
        } else {
          setDiagnosisList([]);
        }
      } catch (err: any) {
        errorMessage("Failed to load diagnosis data");
      }
    };

    fetchDiagnosisData();
  }, [selectedProcedure]);

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id &&
      isPreAuthTabActive()
    ) {
      dispatch(
        getPortalDataStarhealth({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  const refreshData = async () => {
    dispatch(
      getPortalDataStarhealth({
        caseId: patients?.fetchBasicDetails?.casesResponse?.id || 0,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id || 0,
      })
    );
    await getTimelineDetail();
    await fetchStepperForStatus();
    dispatch(
      getBasicDetails({
        id: patients?.fetchBasicDetails?.visitInfoResponse?.id || 0,
      })
    );
    fetchDocuments();
    setConfirmationModal(false);
  };

  useEffect(() => {
    let intervalId: NodeJS.Timeout | null = null;
    let timeoutId: NodeJS.Timeout | null = null;
    let pollCount = 0;
    const maxPolls = 24;
    const modifiedAt = preAuth?.portalData?.modifiedAt;

    const modifiedTime = new Date(modifiedAt).getTime();
    const now = Date.now();
    const diffSeconds = (now - modifiedTime) / 1000;

    if (
      preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
        ?.initiated &&
      !preAuth?.portalData?.casePreAuthStarhealth?.claimId &&
      diffSeconds <= 78
    ) {
      intervalId = setInterval(() => {
        pollCount++;
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          dispatch(
            getPortalDataStarhealth({
              caseId: patients?.fetchBasicDetails?.casesResponse?.id,
              visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            })
          );
        }

        if (preAuth?.portalData?.casePreAuthStarhealth?.claimId) {
          if (intervalId) clearInterval(intervalId);
          if (timeoutId) clearTimeout(timeoutId);
        }

        if (pollCount >= maxPolls) {
          if (intervalId) clearInterval(intervalId);
          // setShowManualClaimIdModal(true);
        }
      }, 5000);

      timeoutId = setTimeout(() => {
        if (intervalId) clearInterval(intervalId);
        // setShowManualClaimIdModal(true);
      }, 120000);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.initiated,
    preAuth?.portalData?.casePreAuthStarhealth?.claimId,
    preAuth?.portalData?.modifiedAt,
  ]);

  useEffect(() => {
    const fetchDiagnosisData = async () => {
      try {
        if (selectedProcedure?.name?.toUpperCase() === "OTHERS") {
          const portalMetaDataId =
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
          const hospitalId =
            patients?.fetchBasicDetails?.casesResponse?.healthCareId;
          const schemeId =
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

          if (portalMetaDataId && hospitalId && schemeId) {
            const res = await getStarHealthSpecialityList(
              portalMetaDataId,
              hospitalId,
              schemeId
            );

            setSpecialityList(
              res?.map((item: any) => ({
                id: item.id,
                departmentName: item.departmentName,
                lineOfTreatmentId: item.lineOfTreatmentId,
                value: item.id,
                label: item.departmentName,
              })) || []
            );
          }
        } else {
          setDiagnosisList([]);
        }
      } catch (err: any) {
        errorMessage("Failed to load diagnosis data");
      }
    };

    fetchDiagnosisData();
  }, [selectedProcedure]);

  // Calculate total amount whenever casePreAuthStarhealthBillDetailsRequestList change
  useEffect(() => {
    if (casePreAuthStarhealthBillDetailsRequestList) {
      const total = casePreAuthStarhealthBillDetailsRequestList.reduce(
        (sum: number, item: any) => {
          const estimateAmount = Number(item?.estimateAmount || 0);
          const numberOfUnits = Number(item?.numberOfUnits || 0);
          return sum + estimateAmount * numberOfUnits;
        },
        0
      );
      setTotalAmount(total);
    }
  }, [casePreAuthStarhealthBillDetailsRequestList]);

  const fetchStepperForStatus = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.id) {
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      dispatch(fetchStepperData({ caseId: caseId, visitId: visitId }));
    }
  };

  const getTimelineDetail = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      await dispatch(
        getTimelineDetails({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
  };

  useEffect(() => {
    if (!isPreAuthTabActive()) return;

    // fetchStepperForStatus();
    // getTimelineDetail();

    setIsApproved(
      preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.approved
    );
  }, [
    preAuth?.portalData,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    activeKey,
  ]);

  const fetchDataForSse = async () => {
    if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
      // dispatch(
      //   getBasicDetails({
      //     id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      //   })
      // );

      dispatch(
        getPortalDataStarhealth({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        })
      );
    }
    fetchStepperForStatus();
    await getTimelineDetail();
    fetchDocuments();
  };

  useEffect(() => {
    if (sseData) {
      fetchDataForSse();
    }
  }, [sseData, sseUpdateCount]);

  const handleGetDocumentsStarHealth = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);

      // if (
      //   validateRequiredDocuments(
      //     documentRequestResponseDocuments["requestedDocuments"],
      //     documentUrls
      //   )
      // ) {
      const formattedValues = {
        ...values,
        casePreAuthRequest: {
          beneficiaryId:
            values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
          patientOpdIpdNumber:
            values.patientOpdIpdNumber ||
            preAuth?.portalData?.patientOpdIpdNumber,
        },
        starhealthHospitalizationReason: {
          id: values.starhealthHospitalizationReason.id,
          name: reasonList?.find(
            (r) =>
              r.starhealthHospitalizationReasonId ===
              values.starhealthHospitalizationReason.id
          )?.eventName,
        },
        dateOfDiagnosis: values.dateOfDiagnosis
          ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        chronicIllnessDate: values.chronicIllnessDate
          ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        casePreAuthStarhealthBillDetailsRequestList:
          values.casePreAuthStarhealthBillDetailsRequestList?.map(
            (item: any) => {
              const category = billCategories?.find(
                (cat) =>
                  cat.irdaiBillCategoryId === Number(item.irdaiBillCategoryId)
              );
              const subCategory = billSubCategories?.find(
                (subCat) =>
                  subCat.id === Number(item.starHealthBillSubCategoryId)
              );

              const subCategoryName = getSubCategoryName(
                item.starHealthBillSubCategoryId,
                item.irdaiBillCategoryId
              );
              return {
                ...item,
                estimateAmount: Number(item.estimateAmount),
                numberOfUnits: Number(item.numberOfUnits),
                irdaiBillCategoryName: category?.masterCategoryName || "",
                starHealthBillSubCategoryName:
                  subCategory?.categoryName || subCategoryName,
              };
            }
          ),
        totalAmount,
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
      };

      const payload = {
        schemeMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
          ?.casePreAuthResponse?.id
          ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.id
          : 0,
        casePreAuthIhxRequest: null,
        casePreAuthCghsRequest: null,
        casePreAuthVidalRequest: null,
        casePreAuthStarhealthRequest: formattedValues,
        casePreAuthEchsRequest: null,
        totalAmount: totalAmount,
      };

      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const portalId =
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
      const schemeMetaDataId =
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

      if (!caseId || !visitId || !portalId || !schemeMetaDataId) {
        errorMessage("Missing required information");
        return;
      }

      const res = await getStarHealthDocuments(caseId, visitId, payload);
      successMessage("PreAuth Saved successfully");
      setConfirmationModal(false);
      setDocumentTags(res?.docsToUpload);
      setShowDocuments(true);
      dispatch(
        getPortalDataStarhealth({
          caseId: patients?.fetchBasicDetails?.casesResponse?.id || 0,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id || 0,
        })
      );
      // } else {
      //   errorMessage("Please, Upload all required documents");
      //   setConfirmationModal(false);
      // }
    } catch (error: any) {
      if (error?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Failed to save PreAuth");
      }
    } finally {
      setConfirmationModal(false);
    }
  };

  const fetchDocuments = async () => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId &&
      patients?.fetchBasicDetails?.casesResponse?.id &&
      patients?.fetchBasicDetails?.visitInfoResponse?.id
    ) {
      try {
        setLoading(true);
        const AllDocumentList = await getAllStarhealthDocumentsData(
          patients?.fetchBasicDetails?.casesResponse?.id,
          patients?.fetchBasicDetails?.visitInfoResponse?.id,
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId
        );
        setDocumentTypes(AllDocumentList?.["PreAuth"]);
      } catch (err) {
        errorMessage("Please, Try again after sometime");
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive())
      fetchDocuments();
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
    activeKey,
  ]);

  // useEffect(() => {
  //   setShowDocuments(preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.submitted ? true : false);
  // }, [preAuth?.portalData])

  const isFetchingDropdownData = React.useRef(false);
  // Fetch all dropdown data on component mount
  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        if (isFetchingDropdownData.current) {
          return;
        }
        isFetchingDropdownData.current = true;
        setIsLoadingDropdowns(true);
        const portalMetaDataId =
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
        const hospitalId =
          patients?.fetchBasicDetails?.casesResponse?.healthCareId;
        const schemeId =
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

        if (!portalMetaDataId || !hospitalId || !schemeId) {
          errorMessage("Missing required case information");
          return;
        }

        // Fetch all dropdown data in parallel
        const [
          reasonResponse,
          // diagnosisResponse,
          chronicResponse,
          procedureResponse,
          qualificationResponse,
          billCategoriesResponse,
        ] = await Promise.all([
          getStarHealthReasonHospitalizationList(portalMetaDataId),
          getStarHealthChronicIllnessList(portalMetaDataId),
          getStarHealthProcedureList(portalMetaDataId, hospitalId, schemeId),
          getDoctorQualification(),
          getBillCategories(portalMetaDataId),
        ]);

        // Set dropdown options with proper formatting
        setReasonList(
          reasonResponse?.map((item: any) => ({
            id: item.id,
            starhealthHospitalizationReasonId:
              item.starhealthHospitalizationReasonId,
            eventName: item.eventName,
            value: item.starhealthHospitalizationReasonId,
            label: item.eventName,
          })) || []
        );

        setChronicIllnessList([
          ...(chronicResponse?.map((item: any) => ({
            id: item.id,
            illnessName: item.illnessName,
            value: item.id,
            label: item.illnessName,
          })) || []),
          { id: 0, illnessName: "OTHERS", value: 0, label: "Others" },
        ]);

        setProcedureList([
          ...([
            ...procedureResponse,
            // { id: 0, procedureMethodName: "Others" },
          ]?.map((item: any) => ({
            id: item.procedureCorporateMappingId,
            procedureMethodName: item.procedureMethodName,
            value: item.procedureCorporateMappingId,
            label: item.procedureMethodName,
            lineOfTreatmentId: item.lineOfTreatmentId,
          })) || []),
          { id: 0, procedureMethodName: "OTHERS", value: 0, label: "Others" },
        ]);

        setQualificationList(
          qualificationResponse?.map((item: any) => ({
            id: item.id,
            qualificationName: item.qualificationName,
            value: item.qualificationName,
            label: item.qualificationName,
          })) || []
        );

        setBillCategories(
          billCategoriesResponse?.map((item: any) => ({
            id: item.irdaiBillCategoryId,
            irdaiBillCategoryId: item.irdaiBillCategoryId,
            irdaiBillCategoryName: item.masterCategoryName,
            masterCategoryName: item.masterCategoryName,
            value: item.irdaiBillCategoryId,
            label: item.masterCategoryName,
          })) || []
        );
      } catch (error) {
        errorMessage("Failed to fetch dropdown data");
        console.error("Error fetching dropdown data:", error);
      } finally {
        setIsLoadingDropdowns(false);
        isFetchingDropdownData.current = false;
      }
    };

    if (activeKey && activeKey?.length > 0 && isPreAuthTabActive())
      fetchDropdownData();
  }, [activeKey]);
  

  const ongoingCategoryRequests = React.useRef<{ [key: number]: boolean }>({});
  // Handle bill category change
  const handleBillCategoryChange = async (categoryId: number) => {
    try {
      if (ongoingCategoryRequests.current[categoryId]) {
        return;
      }
      ongoingCategoryRequests.current[categoryId] = true;
      const portalMetaDataId =
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];
      if (!portalMetaDataId) {
        errorMessage("Missing portal metadata ID");
        return;
      }

      const subCategories = await getBillSubCategories(
        categoryId,
        portalMetaDataId
      );
      setBillSubCategories(
        subCategories?.map((item: any) => ({
          id: item.starHealthBillSubCategoryId,
          categoryName: item.categoryName,
          perUnitAmount: item.perUnitAmount,
          value: item.starHealthBillSubCategoryId,
          label: item.categoryName,
        })) || []
      );

      setAllBillSubCategories((prev) => ({
        ...prev,
        [categoryId]:
          subCategories?.map((item: any) => ({
            id: item.starHealthBillSubCategoryId,
            categoryName: item.categoryName,
            perUnitAmount: item.perUnitAmount,
            value: item.starHealthBillSubCategoryId,
            label: item.categoryName,
          })) || [],
      }));
    } catch (error) {
      errorMessage("Failed to fetch sub-categories");
      console.error("Error fetching sub-categories:", error);
    } finally {
      // Reset the request flag for the category
      ongoingCategoryRequests.current[categoryId] = false;
    }
  };

  const getSubCategoryName = (subCategoryId: number, categoryId: number) => {
    const categorySubCategories = allBillSubCategories[categoryId];
    if (!categorySubCategories) return "";

    const subCategory = categorySubCategories?.find(
      (subCat) => subCat.id === Number(subCategoryId)
    );
    return subCategory?.categoryName || "";
  };

  const preloadSubCategories = async (billDetailsList: any[]) => {
    if (!billDetailsList?.length) return;

    const categoryIds =
      billDetailsList
        ?.map((item) => item?.irdaiBillCategoryId)
        ?.filter((id) => id !== null && id !== undefined && id !== 0) || [];

    const uniqueCategoryIds = Array.from(new Set(categoryIds));

    if (uniqueCategoryIds.length === 0) return;

    await Promise.all(
      uniqueCategoryIds?.map((categoryId) =>
        handleBillCategoryChange(categoryId)
      )
    );
  };

  // Handle adding new bill category
  const handleAddCategory = () => {
    const casePreAuthStarhealthBillDetailsRequestList =
      form.getFieldValue("casePreAuthStarhealthBillDetailsRequestList") || [];
    form.setFieldsValue({
      casePreAuthStarhealthBillDetailsRequestList: [
        ...casePreAuthStarhealthBillDetailsRequestList,
        {},
      ],
    });
  };

  // Handle deleting bill category
  const handleDeleteCategory = async (index: number) => {
    try {
      const casePreAuthStarhealthBillDetailsRequestList = form.getFieldValue(
        "casePreAuthStarhealthBillDetailsRequestList"
      );
      const categoryToDelete =
        casePreAuthStarhealthBillDetailsRequestList[index];
      const portalMetaDataId =
        patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];

      if (categoryToDelete.id && portalMetaDataId) {
        await deleteBillCategory(portalMetaDataId, {
          id: categoryToDelete.id,
          isDeleted: true,
          status: false,
        });
      }

      const newCostDetails = casePreAuthStarhealthBillDetailsRequestList.filter(
        (_: any, i: number) => i !== index
      );
      form.setFieldsValue({
        casePreAuthStarhealthBillDetailsRequestList: newCostDetails,
      });
    } catch (error) {
      errorMessage("Failed to delete category");
      console.error("Error deleting category:", error);
    }
  };

  const validateRequiredDocuments = (
    mandatoryDocuments: any,
    documentUrls: any
  ) => {
    for (const doc of mandatoryDocuments) {
      if (doc.required) {
        const isUploaded = documentUrls?.some(
          (uploadedDoc: any) => uploadedDoc.documentLabelType === doc.label
        );
        if (!isUploaded) {
          return false;
        }
      }
    }
    return true;
  };

  // Handle save draft
  const handleSaveDraft = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);
      setIsSaving(true);
      const formattedValues = {
        ...values,
        casePreAuthRequest: {
          beneficiaryId:
            values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
          patientOpdIpdNumber:
            values.patientOpdIpdNumber ||
            preAuth?.portalData?.patientOpdIpdNumber,
        },
        documentsList: documentUrls,
        starHealthDocumentsQuestionsMappingRequests: documentUrls,
        starhealthHospitalizationReason: {
          id: values.starhealthHospitalizationReason?.id,
          name: reasonList?.find(
            (r) =>
              r.starhealthHospitalizationReasonId ===
              values.starhealthHospitalizationReason?.id
          )?.eventName,
        },
        dateOfDiagnosis: values.dateOfDiagnosis
          ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        chronicIllnessDate: values.chronicIllnessDate
          ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        registrationDate: values?.registrationDate
          ? dayjs(values?.registrationDate).format(dateFormat)
          : null,
        policyInceptionDate: values?.policyInceptionDate
          ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        policyStartDate: values?.policyStartDate
          ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        policyEndDate: values?.policyEndDate
          ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        casePreAuthStarhealthBillDetailsRequestList:
          values.casePreAuthStarhealthBillDetailsRequestList?.map(
            (item: any) => {
              const category = billCategories?.find(
                (cat) =>
                  cat?.irdaiBillCategoryId === Number(item?.irdaiBillCategoryId)
              );
              const subCategory = billSubCategories?.find(
                (subCat) =>
                  subCat?.id === Number(item?.starHealthBillSubCategoryId)
              );

              const subCategoryName = getSubCategoryName(
                item?.starHealthBillSubCategoryId,
                item?.irdaiBillCategoryId
              );
              return {
                ...item,
                estimateAmount: Number(item?.estimateAmount),
                numberOfUnits: Number(item?.numberOfUnits),
                irdaiBillCategoryName: category?.masterCategoryName || "",
                starHealthBillSubCategoryName:
                  subCategory?.categoryName || subCategoryName,
              };
            }
          ),
        totalAmount,
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
      };

      const payload = {
        schemeMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
          ?.casePreAuthResponse?.id
          ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.id
          : 0,
        casePreAuthIhxRequest: null,
        casePreAuthCghsRequest: null,
        casePreAuthVidalRequest: null,
        casePreAuthStarhealthRequest: formattedValues,
        casePreAuthEchsRequest: null,
        totalAmount: totalAmount,
      };

      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

      if (!caseId || !visitId) {
        errorMessage("Missing case or visit information");
        return;
      }

      await saveDraftStarhealth(caseId, visitId, payload);
      successMessage("PreAuth draft saved successfully");
      setConfirmationModal(false);
      await fetchStepperForStatus();
      await getTimelineDetail();
      refreshData();
    } catch (error) {
      errorMessage("Failed to save PreAuth draft");
      console.error("Error saving draft:", error);
    } finally {
      setIsSaving(false);
      setConfirmationModal(false);
    }
  };

  const handleUpdateDraft = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);
      setIsSaving(true);
      const formattedValues = {
        ...values,
        casePreAuthRequest: {
          beneficiaryId:
            values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
          patientOpdIpdNumber:
            values.patientOpdIpdNumber ||
            preAuth?.portalData?.patientOpdIpdNumber,
        },
        documentsList: documentUrls,
        starHealthDocumentsQuestionsMappingRequests: documentUrls,
        starhealthHospitalizationReason: {
          id: values.starhealthHospitalizationReason?.id,
          name: reasonList?.find(
            (r) =>
              r.starhealthHospitalizationReasonId ===
              values.starhealthHospitalizationReason?.id
          )?.eventName,
        },
        dateOfDiagnosis: values.dateOfDiagnosis
          ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        chronicIllnessDate: values.chronicIllnessDate
          ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        registrationDate: values?.registrationDate
          ? dayjs(values?.registrationDate).format(dateFormat)
          : null,
        policyInceptionDate: values?.policyInceptionDate
          ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        policyStartDate: values?.policyStartDate
          ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        policyEndDate: values?.policyEndDate
          ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
          : null,
        casePreAuthStarhealthBillDetailsRequestList:
          values.casePreAuthStarhealthBillDetailsRequestList?.map(
            (item: any) => {
              const category = billCategories?.find(
                (cat) =>
                  cat?.irdaiBillCategoryId === Number(item?.irdaiBillCategoryId)
              );
              const subCategory = billSubCategories?.find(
                (subCat) =>
                  subCat?.id === Number(item?.starHealthBillSubCategoryId)
              );

              const subCategoryName = getSubCategoryName(
                item?.starHealthBillSubCategoryId,
                item?.irdaiBillCategoryId
              );
              return {
                ...item,
                estimateAmount: Number(item?.estimateAmount),
                numberOfUnits: Number(item?.numberOfUnits),
                irdaiBillCategoryName: category?.masterCategoryName || "",
                starHealthBillSubCategoryName:
                  subCategory?.categoryName || subCategoryName,
              };
            }
          ),
        totalAmount,
        caseId: patients?.fetchBasicDetails?.casesResponse?.id,
        visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
        hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
        schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
      };

      const payload = {
        schemeMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        portalMetaDataId:
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
          ?.casePreAuthResponse?.id
          ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.id
          : 0,
        casePreAuthIhxRequest: null,
        casePreAuthCghsRequest: null,
        casePreAuthVidalRequest: null,
        casePreAuthStarhealthRequest: formattedValues,
        casePreAuthEchsRequest: null,
        totalAmount: totalAmount,
      };

      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

      if (!caseId || !visitId) {
        errorMessage("Missing case or visit information");
        return;
      }

      await updateDraftStarhealth(
        caseId,
        visitId,
        preAuth?.portalData?.id,
        payload
      );
      successMessage("PreAuth draft saved successfully");
      setConfirmationModal(false);
      // await fetchStepperForStatus();
      // await getTimelineDetail();
      refreshData();
    } catch (error) {
      errorMessage("Failed to save PreAuth draft");
      console.error("Error saving draft:", error);
    } finally {
      setIsSaving(false);
      setConfirmationModal(false);
    }
  };

  // Handle intimate submission
  const handleIntimateSubmit = async () => {
    try {
      // await form.validateFields();
      const values = await form.getFieldsValue(true);
      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        setIsIntimating(true);
        const formattedValues = {
          ...values,
          casePreAuthRequest: {
            beneficiaryId:
              values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
            patientOpdIpdNumber:
              values.patientOpdIpdNumber ||
              preAuth?.portalData?.patientOpdIpdNumber,
          },
          documentsList: documentUrls,
          starHealthDocumentsQuestionsMappingRequests: documentUrls,
          starhealthHospitalizationReason: {
            id: values.starhealthHospitalizationReason?.id,
            name: reasonList?.find(
              (r) =>
                r.starhealthHospitalizationReasonId ===
                values.starhealthHospitalizationReason?.id
            )?.eventName,
          },
          dateOfDiagnosis: values.dateOfDiagnosis
            ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          registrationDate: values?.registrationDate
            ? dayjs(values?.registrationDate).format(dateFormat)
            : null,
          policyInceptionDate: values?.policyInceptionDate
            ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyStartDate: values?.policyStartDate
            ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyEndDate: values?.policyEndDate
            ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          chronicIllnessDate: values.chronicIllnessDate
            ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          casePreAuthStarhealthBillDetailsRequestList:
            values.casePreAuthStarhealthBillDetailsRequestList?.map(
              (item: any) => {
                const category = billCategories?.find(
                  (cat) =>
                    cat?.irdaiBillCategoryId ===
                    Number(item?.irdaiBillCategoryId)
                );
                const subCategory = billSubCategories?.find(
                  (subCat) =>
                    subCat?.id === Number(item?.starHealthBillSubCategoryId)
                );

                const subCategoryName = getSubCategoryName(
                  item?.starHealthBillSubCategoryId,
                  item?.irdaiBillCategoryId
                );
                return {
                  ...item,
                  estimateAmount: Number(item?.estimateAmount),
                  numberOfUnits: Number(item?.numberOfUnits),
                  irdaiBillCategoryName: category?.masterCategoryName || "",
                  starHealthBillSubCategoryName:
                    subCategory?.categoryName || subCategoryName,
                };
              }
            ),
          totalAmount,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          action: "intimate",
        };

        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
                ?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: formattedValues,
          casePreAuthEchsRequest: null,
          totalAmount: totalAmount,
          action: "intimate",
        };

        const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
        const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
        const portalId =
          patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0];

        if (!caseId || !visitId || !portalId) {
          errorMessage("Missing required information");
          return;
        }

        await saveDraftStarhealth(caseId, visitId, payload);
        successMessage("PreAuth Sent To QC successfully");
        setConfirmationModal(false);
        // await fetchStepperForStatus();
        // await getTimelineDetail();
        refreshData();
      } else {
        errorMessage("Please, Upload all required documents");
        setConfirmationModal(false);
      }
    } catch (error: any) {
      if (error?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Failed to intimate PreAuth");
      }
    } finally {
      setIsIntimating(false);
      setConfirmationModal(false);
    }
  };

  // Handle final submission
  const handleSubmit = async () => {
    try {
      await form.validateFields();
      const values = form.getFieldsValue(true);
      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        setIsSubmitting(true);
        const formattedValues = {
          ...values,
          casePreAuthRequest: {
            beneficiaryId:
              values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
            patientOpdIpdNumber:
              values.patientOpdIpdNumber ||
              preAuth?.portalData?.patientOpdIpdNumber,
          },
          documentsList: documentUrls,
          starHealthDocumentsQuestionsMappingRequests: documentUrls,
          starhealthHospitalizationReason: {
            id: values.starhealthHospitalizationReason.id,
            name: reasonList?.find(
              (r) =>
                r.starhealthHospitalizationReasonId ===
                values.starhealthHospitalizationReason.id
            )?.eventName,
          },
          registrationDate: values?.registrationDate
            ? dayjs(values?.registrationDate).format(dateFormat)
            : null,
          policyInceptionDate: values?.policyInceptionDate
            ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyStartDate: values?.policyStartDate
            ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyEndDate: values?.policyEndDate
            ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          dateOfDiagnosis: values.dateOfDiagnosis
            ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          chronicIllnessDate: values.chronicIllnessDate
            ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          casePreAuthStarhealthBillDetailsRequestList:
            values.casePreAuthStarhealthBillDetailsRequestList?.map(
              (item: any) => {
                const category = billCategories?.find(
                  (cat) =>
                    cat.irdaiBillCategoryId === Number(item.irdaiBillCategoryId)
                );
                const subCategory = billSubCategories?.find(
                  (subCat) =>
                    subCat.id === Number(item.starHealthBillSubCategoryId)
                );

                const subCategoryName = getSubCategoryName(
                  item.starHealthBillSubCategoryId,
                  item.irdaiBillCategoryId
                );
                return {
                  ...item,
                  estimateAmount: Number(item.estimateAmount),
                  numberOfUnits: Number(item.numberOfUnits),
                  irdaiBillCategoryName: category?.masterCategoryName || "",
                  starHealthBillSubCategoryName:
                    subCategory?.categoryName || subCategoryName,
                };
              }
            ),
          totalAmount,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
        };

        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
                ?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: formattedValues,
          casePreAuthEchsRequest: null,
          totalAmount: totalAmount,
          integratedWithPortal:
            patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
        };

        const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
        const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

        if (!caseId || !visitId) {
          errorMessage("Missing case or visit information");
          return;
        }

        await fetchPreAuthToPortalStarhealth(caseId, visitId, payload);
        successMessage("PreAuth submitted successfully");
        setConfirmationModal(false);
        // await fetchStepperForStatus();
        // await getTimelineDetail();
        refreshData();
      } else {
        errorMessage("Please, Upload all required documents");
        setSubmissionModal(false);
        setConfirmationModal(false);
        setIsSubmittedOnPortal(false);
      }
    } catch (error: any) {
      if (error?.errorFields) {
        errorMessage("Please, fill all details before submitting");
      } else {
        errorMessage("Failed to submit PreAuth");
      }
    } finally {
      setIsSubmitting(false);
      setConfirmationModal(false);
    }
  };

  // Initialize form with existing data if available
  useEffect(() => {
    if (preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.id) {
      preloadSubCategories(
        preAuth.portalData.casePreAuthStarhealth?.casePreAuthRequest
          ?.casePreAuthStarhealthBillDetailsResponseList
      );

      const billDetailsWithNames =
        preAuth.portalData?.casePreAuthStarhealth?.casePreAuthStarhealthBillDetailsResponseList?.map(
          (item: any) => {
            const category = billCategories?.find(
              (cat) =>
                cat.irdaiBillCategoryId === Number(item.irdaiBillCategoryId)
            );
            const subCategory = billSubCategories?.find(
              (subCat) => subCat.id === Number(item.starHealthBillSubCategoryId)
            );

            const subCategoryName = getSubCategoryName(
              item.starHealthBillSubCategoryId,
              item.irdaiBillCategoryId
            );
            return {
              ...item,
              irdaiBillCategoryId: Number(item.irdaiBillCategoryId),
              irdaiBillCategoryName: category?.masterCategoryName || "",
              starHealthBillSubCategoryId: Number(
                item.starHealthBillSubCategoryId
              ),
              starHealthBillSubCategoryName:
                subCategory?.categoryName || subCategoryName,
              numberOfUnits: item.numberOfUnits,
              estimateAmount: item.estimateAmount,
            };
          }
        ) || [{}];

      form.setFieldsValue({
        ...preAuth.portalData?.casePreAuthStarhealth,
        starhealthHospitalizationReason:
          preAuth.portalData?.casePreAuthStarhealth
            ?.starhealthHospitalizationReason,
        procedureCorporateMapping:
          preAuth.portalData?.casePreAuthStarhealth?.procedureCorporateMapping,
        starhealthProcedureDiagnosis:
          preAuth.portalData?.casePreAuthStarhealth
            ?.starhealthProcedureDiagnosis,
        dateOfDiagnosis: preAuth.portalData?.casePreAuthStarhealth
          ?.dateOfDiagnosis
          ? dayjs(
              preAuth.portalData?.casePreAuthStarhealth?.dateOfDiagnosis,
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        chronicIllness:
          preAuth.portalData?.casePreAuthStarhealth?.chronicIllness,
        chronicIllnessDate: preAuth.portalData?.casePreAuthStarhealth
          ?.chronicIllnessDate
          ? dayjs(
              preAuth.portalData?.casePreAuthStarhealth?.chronicIllnessDate,
              "DD-MM-YYYY HH:mm:ss"
            )
          : null,
        registrationDate: preAuth?.portalData?.registrationDate
          ? dayjs(preAuth?.portalData?.registrationDate, dateFormat)
          : patients?.fetchBasicDetails?.visitInfoResponse?.doa
          ? dayjs(
              patients?.fetchBasicDetails?.visitInfoResponse?.doa,
              dateFormat
            )
          : null,
        policyDate: preAuth.portalData?.casePreAuthStarhealth?.policyDate
          ? dayjs(
              preAuth.portalData?.casePreAuthStarhealth?.policyDate,
              dateFormat
            )
          : null,
        policyStartDate: preAuth.portalData?.casePreAuthStarhealth
          ?.policyStartDate
          ? dayjs(
              preAuth.portalData?.casePreAuthStarhealth?.policyStartDate,
              dateFormat
            )
          : null,
        policyEndDate: preAuth.portalData?.casePreAuthStarhealth?.policyEndDate
          ? dayjs(
              preAuth.portalData?.casePreAuthStarhealth?.policyEndDate,
              dateFormat
            )
          : null,
        noOfMonths: preAuth.portalData?.casePreAuthStarhealth?.noOfMonths,
        doctorName: preAuth.portalData?.casePreAuthStarhealth?.doctorName,
        doctorQualification:
          preAuth.portalData?.casePreAuthStarhealth?.doctorQualification,
        department: preAuth.portalData?.casePreAuthStarhealth?.department,
        otherProcedureText:
          preAuth.portalData?.casePreAuthStarhealth?.otherProcedureText,
        otherProcedureDiagnosisText:
          preAuth.portalData?.casePreAuthStarhealth
            ?.otherProcedureDiagnosisText,
        casePreAuthStarhealthBillDetailsRequestList:
          billDetailsWithNames?.length > 0 ? billDetailsWithNames : [{}],
        treatmentType: Number(
          preAuth?.portalData?.casePreAuthStarhealth?.treatmentType
        ),
        beneficiaryId:
          preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
            ?.beneficiaryId,
        patientOpdIpdNumber:
          preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
            ?.patientOpdIpdNumber,
        medicalId:
          preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
            ?.beneficiaryId,
      });

      // Load sub-categories for each bill category
      billDetailsWithNames?.forEach((detail: any) => {
        if (detail.irdaiBillCategoryId) {
          handleBillCategoryChange(detail.irdaiBillCategoryId);
        }
      });
    }
  }, [preAuth?.portalData, billCategories]);

  useEffect(() => {
    if (
      patients &&
      !preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.id
    ) {
      form.setFieldsValue({
        beneficiaryId:
          preAuth?.portalData?.beneficiaryId ||
          patients?.fetchBasicDetails?.referralInfoResponse
            ?.cghsReferralResponse?.beneficiaryId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId,
        patientOpdIpdNumber:
          patients?.fetchBasicDetails?.visitInfoResponse?.opNumber,
        medicalId:
          preAuth?.portalData?.medicalId ||
          patients?.fetchBasicDetails?.casesResponse?.memberId,
        registrationDate: preAuth?.portalData?.registrationDate
          ? dayjs(preAuth?.portalData?.registrationDate, dateFormat)
          : patients?.fetchBasicDetails?.visitInfoResponse?.doa
          ? dayjs(
              patients?.fetchBasicDetails?.visitInfoResponse?.doa,
              dateFormat
            )
          : null,
        policyName:
          preAuth?.portalData?.policyName ||
          patients?.fetchBasicDetails?.patientResponse
            ?.patientSchemeNewResponseList?.[0]?.policyName ||
          null,
        policyNumber:
          preAuth?.portalData?.policyNumber ||
          patients?.fetchBasicDetails?.patientResponse
            ?.patientSchemeNewResponseList?.[0]?.policyNumber ||
          null,
        claimRefNo: preAuth?.portalData?.claimRefNo,
        policyDate: preAuth?.portalData?.policyDate
          ? dayjs(preAuth?.portalData?.policyDate, dateFormat)
          : null,
        policyStartDate: preAuth?.portalData?.policyStartDate
          ? dayjs(preAuth?.portalData?.policyStartDate, dateFormat)
          : patients?.fetchBasicDetails?.patientResponse
              ?.patientSchemeNewResponseList?.[0]?.policyStartDate
          ? dayjs(
              patients?.fetchBasicDetails?.patientResponse
                ?.patientSchemeNewResponseList?.[0]?.policyStartDate,
              dateFormat
            )
          : null,
        policyEndDate: preAuth?.portalData?.policyEndDate
          ? dayjs(preAuth?.portalData?.policyEndDate, dateFormat)
          : (patients?.fetchBasicDetails?.patientResponse
              ?.patientSchemeNewResponseList?.[0]?.policyEndDate &&
              dayjs(
                patients?.fetchBasicDetails?.patientResponse
                  ?.patientSchemeNewResponseList?.[0]?.policyEndDate,
                dateFormat
              )) ||
            null,
        claimType: preAuth?.portalData?.claimType || "NON-COVID",
        policyType: preAuth?.portalData?.policyType || "INDIVIDUAL",
        policySource:
          patients?.fetchBasicDetails?.patientResponse
            ?.patientSchemeNewResponseList?.[0]?.policySource || null,
        registrationId: preAuth?.portalData?.schemeRegistrationId,
      });
    }
  }, [patients?.fetchBasicDetails, preAuth?.portalData]);

  useEffect(() => {
    const requestResponseDocuments = {
      requestedDocuments: [] as Document[],
      responseDocuments: [] as Document[],
    };

    documentTypes?.forEach((document) => {
      if (document?.requestDocument) {
        requestResponseDocuments.requestedDocuments.push(document);
      } else if (document?.responseDocument) {
        requestResponseDocuments.responseDocuments.push(document);
      }
    });

    setDocumentRequestResponseDocuments(requestResponseDocuments);
  }, [documentTypes]);

  // Document handling functions
  // const handleFileChange = (documentType: string) => (e: any) => {
  //   if (Array.isArray(e)) {
  //     return e;
  //   }
  //   if (e?.file) {
  //     setSelectedFile({ file: e.file, documentType });
  //     setPreviewFile({
  //       url: URL.createObjectURL(e.file),
  //       name: e.file.name,
  //       showUpload: true,
  //       documentType,
  //     });
  //     setPreviewModalVisible(true);
  //   }
  //   return e?.target?.files;
  // };

  const handleFileChange =
    (documentType: string, isMultiple: boolean) => (e: any) => {
      if (isMultiple) {
        const files = e?.fileList || [];
        setUploadFileList(files);
        if (files.length === 0) return;

        const selected = files?.map((f: any) => ({
          file: f.originFileObj,
          documentType,
        }));

        const previews = files?.map((f: any) => ({
          url: URL.createObjectURL(f.originFileObj),
          name: f.name,
          showUpload: true,
          documentType,
          isMultiple: isMultiple,
        }));

        setSelectedFiles(selected);
        setPreviewFiles(previews);
        setPreviewModalVisible(true);
      } else {
        if (Array.isArray(e)) {
          return e;
        }
        if (e?.file) {
          setSelectedFile({ file: e.file, documentType: documentType });
          setPreviewFile({
            url: URL.createObjectURL(e.file),
            name: e.file.name,
            showUpload: true,
            documentType: documentType,
          });
          setPreviewModalVisible(true);
        }
        return e?.target?.files;
      }
    };

  const renderUploadButton = (
    documentType: string,
    documentTypeId: any,
    isMultiple: boolean
  ) => (
    <Button
      icon={<UploadOutlined />}
      style={{
        display: "flex",
        alignItems: "center",
        borderRadius: 0,
        border: "none",
        borderTopLeftRadius: "6px",
        borderBottomLeftRadius: "6px",
      }}
      disabled={
        // (auth?.role?.role === "FO_STAFF" &&
        //   preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
        //     ?.intimated) ||
        Boolean(preAuth?.portalData?.casePreAuthStarhealth?.claimId) ||
        preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
          ?.submitted ||
        isApproved
      }
      // onClick={() => handleFileChange(docType.label)}
      onClick={() => {
        setSelectedDocumentType({
          documentType: documentTypeId,
          documentLabelType: documentType,
          isMultiple,
        });
        setUploadModalVisible(true);
      }}
    />
  );

  useEffect(() => {
    setDocumentUrls((prevDocuments: any[]) => {
      return prevDocuments?.map((doc) => {
        return { ...doc, documentId: doc?.id };
      });
    });
  }, [documentUrls]);

  useEffect(() => {
    const documentList = [
      ...documentTypes
        .filter(
          (item: any) => item.documentList && item.documentList.length > 0
        )
        .flatMap((item: any, index: number) =>
          item.documentList!?.map((doc: any, docIndex: any) => ({
            ...doc,
            key: `${index + 1}`,
            label: item.label, // Document Type
            documentUrl: doc.documentUrl, // URL for download
            id: doc.id,
            documentType: doc.documentType,
            documentName: doc.documentName,
            deficiencyCheckStatus:
              doc.deficiencyCheckStatus === true
                ? true
                : doc.deficiencyCheckStatus === false
                ? false
                : null,
            deficiency:
              doc.deficiencyCheckStatus === true
                ? true
                : doc.deficiencyCheckStatus === false
                ? false
                : null,
            remarks: doc.remarks || null,
            documentLabelType: doc.documentLabelType,
            actions: item,
          }))
        ),
    ];

    setDocumentUrls(documentList);
  }, [documentTypes]);

  const handleDocumentUpload = async () => {
    setIsUploading(true);
    if (selectedFiles?.length > 0) {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFiles?.[0]?.documentType);

      selectedFiles?.map((fileObj, index) =>
        CollectPostData.append(`file${index}`, fileObj.file)
      );

      // if (selectedFiles?.length > 0) {
      //   selectedFiles.forEach((fileObj, index) => {
      //     // Extract the actual File object from your structure
      //     const actualFile = fileObj.file; // This is the originFileObj (actual File)

      //     if (actualFile instanceof File) {
      //       CollectPostData.append("files", actualFile);
      //     }
      //   });
      // }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setUploadFileList([]);
        setSelectedFiles([]);
        setPreviewFiles([]);
      } catch (error) {
        console.error("Failed to upload document:", error);
      } finally {
        setIsUploading(false);
      }
    } else {
      const CollectPostData = new FormData();
      if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
        CollectPostData.append(
          "hospitalId",
          patients?.fetchBasicDetails?.casesResponse?.healthCareId?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.patientResponse?.id) {
        CollectPostData.append(
          "patientId",
          patients?.fetchBasicDetails?.patientResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.casesResponse?.id) {
        CollectPostData.append(
          "caseId",
          patients?.fetchBasicDetails?.casesResponse?.id?.toString()
        );
      }
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        CollectPostData.append(
          "visitId",
          patients?.fetchBasicDetails?.visitInfoResponse?.id?.toString()
        );
      }
      CollectPostData.append("documentType", previewFile.documentType);

      if (selectedFile?.file) {
        CollectPostData.append("file", selectedFile?.file);
      }

      try {
        const documentRes = await dispatch(
          UploadDocument({
            formData: CollectPostData,
            accessToken: auth.accessToken || "",
          })
        ).unwrap();

        // const updatedDocuments = updateOrAddDocument(documentUrls, documentRes);
        const updatedDocuments = [...documentUrls, ...documentRes];

        setDocumentUrls(updatedDocuments);
        setPreviewModalVisible(false);
        message.success(
          `${documentRes?.[0]?.documentLabelType} uploaded successfully`
        );
        await handleAttachDocuments(documentRes);
        setSelectedFile(null);
        setPreviewFile({
          url: "",
          name: "",
          showUpload: false,
          documentType: "",
        });
      } catch (error) {
        console.error("Failed to upload document:", error);
      } finally {
        setIsUploading(false);
      }
    }
  };

  // const handleDocumentUpload = async (
  //   file: File,
  //   selectedTags: string[],
  //   documentType: string
  // ) => {
  //   try {
  //     setIsUploading(true);

  //     const formData = new FormData();
  //     if (patients?.fetchBasicDetails?.casesResponse?.healthCareId) {
  //       formData.append(
  //         "hospitalId",
  //         patients.fetchBasicDetails.casesResponse.healthCareId.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.patientResponse?.id) {
  //       formData.append(
  //         "patientId",
  //         patients.fetchBasicDetails.patientResponse.id.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.casesResponse?.id) {
  //       formData.append(
  //         "caseId",
  //         patients.fetchBasicDetails.casesResponse.id.toString()
  //       );
  //     }
  //     if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
  //       formData.append(
  //         "visitId",
  //         patients.fetchBasicDetails.visitInfoResponse.id.toString()
  //       );
  //     }
  //     formData.append("documentType", previewFile.documentType);
  //     if (selectedFile?.file) {
  //       formData.append("file", selectedFile.file);
  //     }
  //     // formData.append("documentTags", JSON.stringify(selectedTags));

  //     const documentRes = await dispatch(
  //       UploadDocument({
  //         formData: formData,
  //         accessToken: auth.accessToken || "",
  //       })
  //     ).unwrap();

  //     // const updatedDocuments = updateOrAddDocument(documentUrls, {
  //     //   ...documentRes,
  //     //   documentTags: selectedTags,
  //     // });
  //     const updatedDocuments = [...documentUrls, ...documentRes];

  //     setDocumentUrls(updatedDocuments);
  //     // setUploadModalVisible(false);
  //     setPreviewModalVisible(false);
  //     successMessage(`${documentRes?.[0]?.documentLabelType} uploaded successfully`);
  //   } catch (error) {
  //     console.error("Failed to upload document:", error);
  //     errorMessage("Failed to upload document. Please try again.");
  //   } finally {
  //     setIsUploading(false);
  //   }
  // };

  const updateOrAddDocument = (
    uploadedDocumentUrl: any,
    documentRes: IDocumentFields
  ) => {
    const updatedDocuments = [...uploadedDocumentUrl];

    updatedDocuments.push({
      documentType: documentRes?.documentType,
      documentName: documentRes?.documentName,
      documentUrl: documentRes?.documentUrl,
      documentLabelType: documentRes?.documentLabelType,
      id: documentRes?.id,
      deficiencyCheckStatus: documentRes?.deficiencyCheckStatus,
    });

    return updatedDocuments;
  };

  const handleDownloadDocument = async (fileName: string, url: string) => {
    try {
      await downloadDocument(fileName, url);
      successMessage("Document Downloaded Successfully");
    } catch (error) {
      errorMessage("Failed to download document");
    }
  };

  const handleDeleteList = async (
    documentType: string,
    documentUrl: string,
    i: number
  ) => {
    const combinedUrls: any = [...documentUrls];
    const deleteDocument = combinedUrls?.find(
      (doc: any, index: any) => doc?.documentUrl === documentUrl
    );
    const deleteForm = {
      documentUrl: deleteDocument?.documentUrl,
      status: false,
      id: deleteDocument?.id,
    };

    const newUpdatedDocumentList = documentUrls?.filter(
      (doc: any, index: any) => doc?.documentUrl !== documentUrl
    );
    setDocumentUrls(newUpdatedDocumentList);

    if (deleteDocument?.documentUrl) {
      try {
        await deleteUploadedDocument(deleteForm);
      } catch (err) {
        console.error(err);
        message.error("Please, Try again later");
      }
      // fetchDocuments();
    }
  };

  // Modal handling functions
  const handleSaveDraftClick = async (values: FormValues): Promise<void> => {
    setModalValues(values);
    setShowSaveModal(true);
  };

  const handleIntimateClick = async (values: FormValues): Promise<void> => {
    setModalValues(values);
    setShowIntimateModal(true);
  };

  const handleSubmitClick = async (values: FormValues): Promise<void> => {
    setModalValues(values);
    setShowSubmitModal(true);
  };

  // Submission handling functions
  const handleSubmitToPortal = async () => {
    if (patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal) {
      try {
        await form.validateFields();
        setIsSubmittedOnPortal(true);
      } catch (err: any) {
        if (err?.errorFields) {
          errorMessage("Please fill all required fields before submitting");
        } else {
          errorMessage("Please try again later");
        }
        setIsSubmittedOnPortal(false);
        setConfirmationModal(false);
      }
    } else {
      setManuallyClaimIdPortal(true);
    }
  };

  const handleSaveConfirmationModal = async (confirmationState: string) => {
    if (confirmationState === "intimate") {
      if (auth?.role?.role !== "FO_STAFF") {
        try {
          await form.validateFields();
        } catch (err: any) {
          if (err?.errorFields) {
            errorMessage("Please, fill all details before submitting");
          } else {
            errorMessage("Failed to intimate PreAuth");
          }
          return;
        }
      }
      if (
        !validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls,
        )
      ) {
        errorMessage("Please, Upload all required documents");
        return;
      }
    }

    setConfirmationModal(true);
    setConfirmationState(confirmationState);

    if (confirmationState === "save") {
      setTitle("Do you want to save PreAuth?");
    } else if (confirmationState === "update") {
      setTitle("Do you want to update PreAuth?");
    } else if (confirmationState === "intimate") {
      setTitle("Do you want to send PreAuth for QC?");
    } else if (confirmationState === "submit") {
      setTitle("Do you want to submit PreAuth?");
    } else if (confirmationState === "approve") {
      setTitle("Do you want to approve PreAuth?");
    }
  };

  const handleSave = async () => {
    if (confirmationState === "save") {
      await handleSaveDraft();
    } else if (confirmationState === "update") {
      await handleUpdateDraft();
    } else if (confirmationState === "intimate") {
      await handleIntimateSubmit();
    } else if (confirmationState === "submit") {
      await handleSubmitToPortal();
    } else if (confirmationState === "approve") {
      await handleApprove();
    }
    setConfirmationModal(false);
  };

  const handleCancelSubmissionPortal = () => {
    setIsSubmittedOnPortal(false);
    setSubmissionModal(true);
  };

  const handleManuallyIdEnter = () => {
    setIsSubmittedOnPortal(false);
    setIsManuallyEnteredId(true);
  };

  const handleCancelManuallyId = () => {
    setIsManuallyEnteredId(false);
  };

  // Add missing deficiency modal functions
  const handleDeficiencyModalOpen = async (
    documentUrl: string,
    documentId: number,
    document: any
  ) => {
    await fetchDeficiencyData(document, document?.id);
    setSelectedDocument(document);
    // setDeficiencyModal(true);
  };

  const closeDeficiencyModal = () => {
    setDeficiencyModal(false);
    setSelectedDocument(null);
  };

  // Add missing portal submission functions
  const handleOk = () => {
    setSubmissionModal(false);
  };

  const handleRegistrationCancel = () => {
    setSubmissionModal(false);
  };

  const handleSaveModalOption = async () => {
    setSubmissionModal(false);
    await handleSubmit();
  };

  const handleAttachDocuments = async (updatedDocumentUrls: any) => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    payloadSchema["casePreAuthAttachments"] = updatedDocumentUrls;

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const handleSaveData = async () => {
    const payloadSchema: {
      casePreAuthAttachments: any[];
      caseEnhancementsAttachments: any[];
      caseDischargeAttachments: any[];
      caseClaimAttachments: any[];
    } = {
      casePreAuthAttachments: [],
      caseEnhancementsAttachments: [],
      caseDischargeAttachments: [],
      caseClaimAttachments: [],
    };

    const updatedDocumentUrls: any = documentUrls?.filter((document: any) =>
      documentRequestResponseDocuments["responseDocuments"]?.some(
        (doc: any) => doc?.label === document?.documentLabelType
      )
    );

    payloadSchema["casePreAuthAttachments"] = updatedDocumentUrls;

    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;

    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const schemeMetaDataId =
      patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId;

    if (caseId && visitId && schemeMetaDataId) {
      try {
        const AllDocumentList = await updateAllDocumentsData(
          caseId,
          visitId,
          payloadSchema
        );
        message.success(`Response documents saved successfully`);
        fetchDocuments();
      } catch (error) {
        message.error(`Something went wrong`);
      }
    }
  };

  const fetchDeficiencyData = async (
    selectedDocument: any,
    selectedDocumentId: any
  ) => {
    try {
      if (selectedDocumentId) {
        // dispatch(clearDeficiencyCheck());
        // const firstRes = await dispatch(
        //   getDeficiencyQuestions(selectedDocumentId)
        // );
        setFetchingDeficiencyData(true);
        const secondRes = await dispatch(
          getDeficiencyQuestionData(selectedDocumentId)
        );
        setFetchingDeficiencyData(false);
      }
    } catch (err) {
      errorMessage("Please, Try again after sometime");
      setSelectedDocument(null);
      setFetchingDeficiencyData(false);
    }
  };

  const handleOpen = (docType: any, documentUrl: any) => {
    setPreviewDocument(true);
    setClickedActiveTab(docType);
    setClickedActiveDocumentUrl(documentUrl);
  };

  // Add handleApprove function
  const handleApprove = async () => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);
      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        setIsApprovedInitiated(true);
        const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
        const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;

        if (!caseId || !visitId) {
          errorMessage("Missing case or visit information");
          return;
        }

        const formattedValues = {
          ...values,
          casePreAuthRequest: {
            beneficiaryId:
              values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
            patientOpdIpdNumber:
              values.patientOpdIpdNumber ||
              preAuth?.portalData?.patientOpdIpdNumber,
          },
          documentsList: documentUrls,
          starHealthDocumentsQuestionsMappingRequests: documentUrls,
          registrationDate: values?.registrationDate
            ? dayjs(values?.registrationDate).format(dateFormat)
            : null,
          policyInceptionDate: values?.policyInceptionDate
            ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyStartDate: values?.policyStartDate
            ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          policyEndDate: values?.policyEndDate
            ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
            : null,
          starhealthHospitalizationReason: {
            id: values.starhealthHospitalizationReason.id,
            name: reasonList?.find(
              (r) =>
                r.starhealthHospitalizationReasonId ===
                values.starhealthHospitalizationReason.id
            )?.eventName,
          },
          dateOfDiagnosis: values.dateOfDiagnosis
            ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          chronicIllnessDate: values.chronicIllnessDate
            ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MM-YYYY HH:mm:ss"
              )
            : null,
          casePreAuthStarhealthBillDetailsRequestList:
            values.casePreAuthStarhealthBillDetailsRequestList?.map(
              (item: any) => {
                const category = billCategories?.find(
                  (cat) =>
                    cat.irdaiBillCategoryId === Number(item.irdaiBillCategoryId)
                );
                const subCategory = billSubCategories?.find(
                  (subCat) =>
                    subCat.id === Number(item.starHealthBillSubCategoryId)
                );

                const subCategoryName = getSubCategoryName(
                  item.starHealthBillSubCategoryId,
                  item.irdaiBillCategoryId
                );
                return {
                  ...item,
                  estimateAmount: Number(item.estimateAmount),
                  numberOfUnits: Number(item.numberOfUnits),
                  irdaiBillCategoryName: category?.masterCategoryName || "",
                  starHealthBillSubCategoryName:
                    subCategory?.categoryName || subCategoryName,
                };
              }
            ),
          totalAmount,
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          hospitalId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
          schemeId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
        };

        const payload = {
          schemeMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          portalMetaDataId:
            patients?.fetchBasicDetails?.casesResponse?.portalMetaDataIds?.[0],
          casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
            ?.casePreAuthResponse?.id
            ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
                ?.id
            : 0,
          casePreAuthIhxRequest: null,
          casePreAuthCghsRequest: null,
          casePreAuthVidalRequest: null,
          casePreAuthStarhealthRequest: formattedValues,
          casePreAuthEchsRequest: null,
          totalAmount: totalAmount,
        };

        const updatedFormData = {
          caseId: patients?.fetchBasicDetails?.casesResponse?.id,
          visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          stage: "PreAuth",
          approved: true,
          casePreAuthId:
            preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
              ?.id || 0,
          preAuthRequest: payload,
        };

        const res = await submitApprovalStarhealth(updatedFormData);
        setIsApproved(true);
        setIsApprovedInitiated(false);
        message.success("PreAuth Approved Successfully");
        setConfirmationModal(false);
        refreshData();
      } else {
        errorMessage("Please, Upload all required documents");
        setSubmissionModal(false);
        setConfirmationModal(false);
      }
    } catch (err: any) {
      if (err?.errorFields) {
        errorMessage("Please, fill all details before submitting");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      } else {
        errorMessage("Please, Try again later");
        setIsApprovedInitiated(false);
        setIsApproved(false);
      }
      setConfirmationModal(false);
    } finally {
      setIsApprovedInitiated(false);
      setConfirmationModal(false);
    }
  };

  const handleSaveManually = async (formValues: any) => {
    try {
      await form.validateFields();
      const values = await form.getFieldsValue(true);
      if (
        validateRequiredDocuments(
          documentRequestResponseDocuments["requestedDocuments"],
          documentUrls
        )
      ) {
        if (
          patients?.fetchBasicDetails?.casesResponse?.id &&
          patients?.fetchBasicDetails?.visitInfoResponse?.id
        ) {
          const formattedValues = {
            ...values,
            casePreAuthRequest: {
              beneficiaryId:
                values.beneficiaryId || preAuth?.portalData?.beneficiaryId,
              patientOpdIpdNumber:
                values.patientOpdIpdNumber ||
                preAuth?.portalData?.patientOpdIpdNumber,
            },
            documentsList: documentUrls,
            starHealthDocumentsQuestionsMappingRequests: documentUrls,
            starhealthHospitalizationReason: {
              id: values.starhealthHospitalizationReason.id,
              name: reasonList?.find(
                (r) =>
                  r.starhealthHospitalizationReasonId ===
                  values.starhealthHospitalizationReason.id
              )?.eventName,
            },
            dateOfDiagnosis: values.dateOfDiagnosis
              ? dayjs(values.dateOfDiagnosis, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss"
                )
              : null,
            chronicIllnessDate: values.chronicIllnessDate
              ? dayjs(values.chronicIllnessDate, "DD-MM-YYYY HH:mm:ss").format(
                  "DD-MM-YYYY HH:mm:ss"
                )
              : null,
            registrationDate: values?.registrationDate
              ? dayjs(values?.registrationDate).format(dateFormat)
              : null,
            policyInceptionDate: values?.policyInceptionDate
              ? dayjs(values?.policyInceptionDate).format("DD-MM-YYYY HH:mm:ss")
              : null,
            policyStartDate: values?.policyStartDate
              ? dayjs(values?.policyStartDate).format("DD-MM-YYYY HH:mm:ss")
              : null,
            policyEndDate: values?.policyEndDate
              ? dayjs(values?.policyEndDate).format("DD-MM-YYYY HH:mm:ss")
              : null,
            casePreAuthStarhealthBillDetailsRequestList:
              values.casePreAuthStarhealthBillDetailsRequestList?.map(
                (item: any) => {
                  const category = billCategories?.find(
                    (cat) =>
                      cat.irdaiBillCategoryId ===
                      Number(item.irdaiBillCategoryId)
                  );
                  const subCategory = billSubCategories?.find(
                    (subCat) =>
                      subCat.id === Number(item.starHealthBillSubCategoryId)
                  );

                  const subCategoryName = getSubCategoryName(
                    item.starHealthBillSubCategoryId,
                    item.irdaiBillCategoryId
                  );
                  return {
                    ...item,
                    estimateAmount: Number(item.estimateAmount),
                    numberOfUnits: Number(item.numberOfUnits),
                    irdaiBillCategoryName: category?.masterCategoryName || "",
                    starHealthBillSubCategoryName:
                      subCategory?.categoryName || subCategoryName,
                  };
                }
              ),
            totalAmount,
            caseId: patients?.fetchBasicDetails?.casesResponse?.id,
            visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
            hospitalId:
              patients?.fetchBasicDetails?.casesResponse?.healthCareId,
            schemeId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
          };

          const updatedData = {
            ...formattedValues,
            manualPreAuth: true,
            claimId: formValues?.manualId,
          };

          const payload = {
            schemeMetaDataId:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
            portalMetaDataId:
              patients?.fetchBasicDetails?.casesResponse
                ?.portalMetaDataIds?.[0],
            casePreAuthId: preAuth?.portalData?.casePreAuthStarhealth
              ?.casePreAuthResponse?.id
              ? preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
                  ?.id
              : 0,
            casePreAuthIhxRequest: null,
            casePreAuthCghsRequest: null,
            casePreAuthVidalRequest: null,
            casePreAuthStarhealthRequest: updatedData,
            casePreAuthEchsRequest: null,
            totalAmount: totalAmount,
            integratedWithPortal:
              patients?.fetchBasicDetails?.casesResponse?.integratedWithPortal,
          };

          const res = await validationPreAuth(
            patients?.fetchBasicDetails?.casesResponse?.id,
            patients?.fetchBasicDetails?.visitInfoResponse?.id,
            payload
          );

          if (res?.success || true) {
            setIsSubmitting(true);
            const resp = await fetchPreAuthToPortalStarhealth(
              patients?.fetchBasicDetails?.casesResponse?.id,
              patients?.fetchBasicDetails?.visitInfoResponse?.id,
              payload
            );
            successMessage("PreAuth Submitted Successfully");
            setConfirmationModal(false);
            setIsSubmitting(false);
            setManuallyClaimIdPortal(false);
            if (resp) {
              dispatch(
                getPortalDataStarhealth({
                  caseId: patients?.fetchBasicDetails?.casesResponse?.id,
                  visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                })
              );
              fetchDocuments();
              await getTimelineDetail();
              await fetchStepperForStatus();
              dispatch(
                getBasicDetails({
                  id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
                })
              );
            }
          }
          // else if (res?.message === "Registration id not found") {
          //   errorMessage("Registration Id is not found");
          //   setIsSubmitting(false);
          //   return;
          // }

          setIsManuallyEnteredId(false);
          setIsSubmitting(false);
          setManuallyClaimIdPortal(false);
        }
      } else {
        errorMessage("Please, Upload all required documents");
        setSubmissionModal(false);
        setIsManuallyEnteredId(false);
        setIsSubmitting(false);
        setManuallyClaimIdPortal(false);
      }
    } catch (err) {
      errorMessage("Please, Try again later");
      setManuallyClaimIdPortal(false);
    }
    setIsSubmitting(false);
    setIsManuallyEnteredId(false);
    setManuallyClaimIdPortal(false);
  };

  const [rightSidePreviewDocument, setRightSidePreviewDocument] =
    useState<boolean>(false);
  const [documentUrl, setDocumentUrl] = useState<any>("");

  const handlePreviewDocument = (url: string) => {
    setRightSidePreviewDocument(true);
    setDocumentUrl(url);
  };

  const isPreAuthSubmitted =
    Boolean(preAuth?.portalData?.casePreAuthStarhealth?.claimId) ||
    Boolean(
      preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.submitted,
    );
  const showVerifyButton = Boolean(
    preAuth?.portalData?.casePreAuthStarhealth?.claimId ||
      preAuth?.portalData?.schemeRegistrationId,
  );

  const handleClaimValidation = async () => {
    await handlePortalClaimValidationFlow({
      scheme: "STAR_HEALTH",
      caseId: patients?.fetchBasicDetails?.casesResponse?.id,
      visitId: patients?.fetchBasicDetails?.visitInfoResponse?.id,
      healthcareId: patients?.fetchBasicDetails?.casesResponse?.healthCareId,
      schemeId: patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataId,
      claimId:
        preAuth?.portalData?.schemeRegistrationId ||
        preAuth?.portalData?.casePreAuthStarhealth?.claimId,
      portalData: preAuth?.portalData,
      patients,
      setIsValidationLoading,
      setValidationRes,
      setRegistrationValidationStatus,
      setIsValidationModalOpen,
    });
  };

  const handleUpdateClaimValidation = async (data: any) => {
    try {
      await updatePortalClaimValidation(
        "STAR_HEALTH",
        patients?.fetchBasicDetails?.casesResponse?.id,
        patients?.fetchBasicDetails?.visitInfoResponse?.id,
        data,
      );
      successMessage("Details Updated Successfully");
      if (patients?.fetchBasicDetails?.visitInfoResponse?.id) {
        await dispatch(
          getBasicDetails({
            id: patients?.fetchBasicDetails?.visitInfoResponse?.id,
          }),
        );
      }
      if (
        patients?.fetchBasicDetails?.casesResponse?.id &&
        patients?.fetchBasicDetails?.visitInfoResponse?.id
      ) {
        await dispatch(
          getPortalDataStarhealth({
            caseId: patients.fetchBasicDetails.casesResponse.id,
            visitId: patients.fetchBasicDetails.visitInfoResponse.id,
          }),
        );
      }
    } catch (err) {
      errorMessage("Please, Try again later");
    }
  };

  return (
    <div>
      <PreAuthStarHealth
        form={form}
        onAddCategory={handleAddCategory}
        onDeleteCategory={handleDeleteCategory}
        onFinish={handleSubmitClick}
        onSaveDraft={handleSaveDraftClick}
        onIntimateSubmit={handleIntimateClick}
        totalAmount={totalAmount}
        isLoading={isLoading || isLoadingDropdowns}
        isSaving={isSaving}
        isSubmitting={isSubmitting}
        isIntimating={isIntimating}
        reasonList={reasonList}
        diagnosisList={diagnosisList}
        chronicIllnessList={chronicIllnessList}
        procedureList={procedureList}
        specialityList={specialityList}
        qualificationList={qualificationList}
        billCategories={billCategories}
        billSubCategories={billSubCategories}
        onBillCategoryChange={handleBillCategoryChange}
        handleFileChange={handleFileChange}
        documentTypes={documentTypes}
        documentUrls={documentUrls}
        handleSubmit={handleSubmitToPortal}
        handleSaveConfirmationModal={handleSaveConfirmationModal}
        loading={loading}
        portalData={preAuth?.portalData}
        documentRequestResponseDocuments={documentRequestResponseDocuments}
        preAuth={preAuth}
        isApproved={isApproved}
        isApprovedInitiated={isApprovedInitiated}
        handleApprove={handleApprove}
        activeKey={activeKey}
        handleSaveData={handleSaveData}
        handleOpen={handleOpen}
        disabled={
          preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
            ?.submitted
        }
        showDocuments={showDocuments}
        handleGetDocumentsStarHealth={handleGetDocumentsStarHealth}
        renderUploadButton={renderUploadButton}
        uploadFileList={uploadFileList}
        isSubmitted={isPreAuthSubmitted}
        showVerifyButton={showVerifyButton}
        isValidationLoading={isValidationLoading}
        registrationValidationStatus={registrationValidationStatus}
        handleClaimValidation={handleClaimValidation}
      />

      {selectedFile?.file && !selectedFiles?.length && (
        <FilePreviewModal
          isVisible={previewModalVisible}
          onClose={() => setPreviewModalVisible(false)}
          fileUrl={previewFile.url}
          fileName={previewFile.name}
          documentType={previewFile.documentType}
          handleUpload={handleDocumentUpload}
          showUploadButton={previewFile.showUpload}
          key={selectedFile?.file?.lastModified || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <PatientDetailsStageDocument
        handleCancel={() => setPreviewDocument(false)}
        handleDeleteDocument={handleDeleteList}
        open={previewDocument}
        handleDownloadDocument={handleDownloadDocument}
        claimId={preAuth?.portalData?.casePreAuthStarhealth?.claimId}
        documents={documentUrls}
        handleDeficiencyModal={handleDeficiencyModalOpen}
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        setDocumentName={setDocumentName}
        setUploadedDocumentUrl={setDocumentUrls}
        activeKey={activeKey}
        clickedActiveTab={clickedActiveTab}
        isSubmittedStatus={preAuth?.portalData?.casePreAuthStarhealth?.claimId}
        isIntimated={preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse?.intimated}
        fetchingDeficiencyData={fetchingDeficiencyData}
        selectedDocument={selectedDocument}
        clickedActiveDocumentUrl={clickedActiveDocumentUrl}
      />

      <DocumentDeficiencyModal
        closeDeficiencyModal={closeDeficiencyModal}
        deficiencyModal={deficiencyModal}
        documentUrl={previewFile.url}
        documentName={documentName}
        handleDownloadDocument={handleDownloadDocument}
        deficiencyQuestions={patients?.deficiencyCheckQuestions}
        selectedDocument={selectedDocument}
        setUploadedDocumentUrl={setDocumentUrls}
      />

      <PortalSubmissionModal
        open={isSubmittedOnPortal}
        title={"Is PreAuth Already Submitted on Portal?"}
        handleCancel={handleCancelSubmissionPortal}
        handleSave={handleManuallyIdEnter}
      />

      <ManuallyIdModal
        open={isManuallyEnteredId}
        title={"Enter Claim Id"}
        handleCancel={handleCancelManuallyId}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isSubmitting}
      />

      <PortalSubmitModal
        open={submissionModal}
        title={"Do You want to Register PreAuth?"}
        handleOk={handleOk}
        handleCancel={handleRegistrationCancel}
        handleSave={handleSaveModalOption}
        isLoading={isSubmitting}
      />

      <ConfirmSubmissionModalStage
        open={confirmationModal}
        title={title}
        handleCancel={() => setConfirmationModal(false)}
        handleSave={handleSave}
        isLoading={
          isSubmitting || isSaving || isApprovedInitiated || isIntimating
        }
      />

      <DocumentUploadModal
        isVisible={uploadModalVisible}
        onClose={() => setUploadModalVisible(false)}
        documentType={selectedDocumentType}
        setDocumentUrls={setDocumentUrls}
        handleFileChange={handleFileChange}
        loading={isUploading}
        documentTags={documentTags}
        documentUrls={documentUrls}
        handleDeleteList={handleDeleteList}
        handleDownloadDocument={handleDownloadDocument}
        handleOpen={handlePreviewDocument}
        uploadFileList={uploadFileList}
        isIntimated={
          preAuth?.portalData?.casePreAuthStarhealth?.casePreAuthResponse
            ?.intimated
        }
      />

      <RightSidePreviewModal
        key={documentUrl}
        documentUrl={documentUrl}
        handleCancel={() => setRightSidePreviewDocument(false)}
        open={rightSidePreviewDocument}
      />

      <ManuallyClaimIdPortal
        open={manuallyClaimIdPortal}
        title={"Enter Claim Id"}
        handleCancel={() => setManuallyClaimIdPortal(false)}
        handleSave={handleSaveManually}
        footer={"Save"}
        isLoading={isSubmitting}
      />

      {selectedFiles?.length > 0 && (
        <MultipleFilesPreviewModal
          isVisible={previewModalVisible}
          onClose={() => {
            setPreviewModalVisible(false);
            setSelectedFiles([]);
            setUploadFileList([]);
          }}
          files={previewFiles}
          handleUpload={handleDocumentUpload}
          showUploadButton={previewFiles?.some((f) => f.showUpload)}
          key={previewFiles?.map((f) => f.name).join(",") || "no-file"}
          isLoading={enhancement?.isLoading}
        />
      )}

      <PortalClaimValidationModal
        open={isValidationModalOpen}
        onCancel={() => setIsValidationModalOpen(false)}
        validationRes={validationRes}
        scheme="STAR_HEALTH"
        onUpdate={handleUpdateClaimValidation}
      />
    </div>
  );
};

export default PreAuthStarHealthContainer;
